import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlCargo = '/service/basico/funcionario/cargo'

class CargoService extends BaseService {
    constructor() {
        super(NOME_TOKEN_ACESSO_DIRETO)
    }

    getCargos() {
        return this.conex.get(urlCargo + '/')
    }
}

export default CargoService
